module.exports = __webpack_public_path__ + "img/decision.09f89286.svg";